






































import { Component, Mixins, Prop } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../system/mixins";
import { DocumentInjectedEvidence, IReplaceParameters } from "../../../../../../../domain/document";
import InjectedObjectEvidenceFilter from "../InjectedObjectEvidenceFilter.vue";
import InjectedObjectEvidenceDrawer from "../InjectedObjectEvidenceDrawer.vue";

@Component({
  components: {
    InjectedObjectEvidenceFilter,
    InjectedObjectEvidenceDrawer,
  }
})
export default class InjectedObjectEvidenceListDialog extends Mixins(DialogMixin) {
  @Prop()
  replaceParameters: IReplaceParameters;

  data(): any {
    return {
      evidences: [],
      filteredEvidences: [],
    };
  }
  evidences: DocumentInjectedEvidence[];
  filteredEvidences: DocumentInjectedEvidence[];

  get title(): string {
    return "診療録一覧(" + this.evidences.length + "件)";
  }

  get hasEvidences(): boolean {
    return this.evidences && this.evidences.length > 0;
  }

  async show(evidences: DocumentInjectedEvidence[]): Promise<void> {
    return this.showModal(async () => {
      this.evidences = evidences;
      await this.waitHidden();
    });
  }

  close(): void {
    this.isVisible = false;
  }
}
